export default "__VITE_ASSET__Ke8Bni6z__"